<div class="container postulacion-container mb-5">
	<div class="row mt-2 info-postulacion-container justify-content-center">
		<div class="mr-2 job-apply-card">

			<form-steps [pasos]="pasos" [pasoActual]="pasoActual" [puedeAvanzar]="puedeAvanzar"
				(cambioPaso)="actualizarPaso($event)">
				<div class="container" *ngIf="pasoActual === 1">

					<div class="card">
						<div class="card-body">
							<div class="container my-5 text-center" *ngIf="!banderacargocv">
								<i class="bi bi-upload display-1 text-primary mb-4"></i>
								<h4 class="fw-bold mb-3">¡Carga tu CV!</h4>
								<p class="text-muted mb-4">
									Sube tu CV en formato PDF o Word. Tamaño máximo: <strong>2MB</strong>.
								</p>

								<!-- File Upload -->
								<div class="mb-4">
									<input type="file" class="form-control w-50 mx-auto" (change)="cargarCV($event)"
										accept=".pdf,.docx">
								</div>

								<!-- Mostrar nombre del archivo -->
								<div *ngIf="selectedFile" class="mb-3">
									<span class="badge bg-light text-dark p-2">{{ selectedFile.name }}</span>

									<!-- Botón para procesar con IA -->
									<div class="mt-3">
										<button type="button" class="btn btn-success" (click)="obtieneInfoCVAI()">
											<i class="bi bi-robot"></i> Procesar con IA
										</button>
									</div>
								</div>

								<!-- Mensaje de error -->
								<div *ngIf="fileSizeError" class="alert alert-danger w-50 mx-auto p-2">
									El archivo excede los 2MB. Por favor selecciona otro archivo.
								</div>
							</div>

							<!-- Mensaje de CV procesado exitosamente -->
							<div class="container my-5 text-center" *ngIf="banderacargocv">
								<i class="bi bi-check-circle-fill display-1 text-success mb-4"></i>
								<h4 class="fw-bold mb-3 text-success">¡Tu CV se procesó exitosamente!</h4>
								<p class="text-muted mb-4">
									En breve recibirás una notificación por correo electrónico con tus datos de acceso.
									Ahora puedes explorar las vacantes disponibles que coincidan con tu perfil.
								</p>

								<!-- Botones de acción -->
								<div class="d-flex justify-content-center gap-3 flex-wrap">
									<a href="/" class="btn btn-primary btn-lg rounded-pill px-4 py-2">
										<i class="bi bi-search me-2"></i>Ver Vacantes Disponibles
									</a>
								</div>

								<!-- Información adicional -->
								<div class="mt-4 p-3 bg-light rounded">
									<small class="text-muted">
										<i class="bi bi-info-circle me-1"></i>
										Tu información ha sido procesada automáticamente.
									</small>
								</div>
							</div>
						</div>
					</div>
				</div>


				<div class="container" *ngIf="pasoActual === 2">
					<div class="card w-100 w-lg-50 mx-auto">
						<div class="card-body">
							<div class="container mt-5">
								<h4 class="mb-4">Datos Personales</h4>

								<!-- Sección de carga de archivo -->
								<div class="mb-3">
									<!-- datos-personales.component.html -->
									<div class="container mt-4">
										<form [formGroup]="personalForm" novalidate>

											<div class="row mb-3">
												<div class="col-md-6">
													<label class="form-label">Nombre</label>
													<input type="text" class="form-control"
														[ngClass]="{'is-invalid': isInvalid('nombre')}"
														formControlName="nombre">
													<div class="invalid-feedback">
														Nombre es requerido y solo debe contener letras.
													</div>
												</div>

												<div class="col-md-6">
													<label class="form-label">Apellidos</label>
													<input type="text" class="form-control"
														[ngClass]="{'is-invalid': isInvalid('apellidos')}"
														formControlName="apellidos">
													<div class="invalid-feedback">
														Apellidos son requeridos y solo deben contener letras.
													</div>
												</div>
											</div>

											<div class="row mb-3">
												<div class="col-md-6">
													<label class="form-label">Correo Electrónico</label>
													<input type="email" class="form-control"
														[ngClass]="{'is-invalid': isInvalid('correo')}"
														formControlName="correo">
													<div class="invalid-feedback">
														Ingrese un correo válido.
													</div>
												</div>

												<div class="col-md-6">
													<label class="form-label">Celular</label>
													<input type="text" class="form-control"
														[ngClass]="{'is-invalid': isInvalid('celular')}"
														formControlName="celular">
													<div class="invalid-feedback">
														Celular de 10 dígitos es requerido.
													</div>
												</div>
											</div>

											<div class="row mb-3">
												<div class="col-md-6">
													<label class="form-label">Entidad Federativa</label>
													<input type="text" class="form-control"
														[ngClass]="{'is-invalid': isInvalid('entidadFederativa')}"
														formControlName="entidadFederativa">
													<div class="invalid-feedback">
														La entidad federativa es requerida.
													</div>
												</div>

												<div class="col-md-6">
													<label class="form-label">Municipio</label>
													<input type="text" class="form-control"
														[ngClass]="{'is-invalid': isInvalid('municipio')}"
														formControlName="municipio">
													<div class="invalid-feedback">
														El municipio es requerido.
													</div>
												</div>
											</div>

											<div class="mb-3">
												<label class="form-label">Perfil del Candidato</label>
												<textarea rows="3" class="form-control"
													[ngClass]="{'is-invalid': isInvalid('perfil')}"
													formControlName="perfil"></textarea>
												<div class="invalid-feedback">
													El perfil del candidato es requerido.
												</div>
											</div>

										</form>
									</div>
								</div>
							</div>

						</div>
					</div>
				</div>

				<!-- Experiencia laboral -->
				<div class="container" *ngIf="pasoActual === 3">
					<div class="container mt-4">
						<!-- Experiencia profesional -->
						<div class="d-flex justify-content-between align-items-center mb-2">
							<h5 class="fw-bold mb-0">Experiencia profesional</h5>
							<button class="btn btn-outline-primary btn-sm"
								(click)="agregarExperiencia()">Agregar</button>
						</div>

						<div class="card shadow-sm mb-4">
							<div class="card-body">
								<!-- Contenedor vacío -->
								<div class="container my-5 text-center"
									*ngIf="experiencia.length === 0 && !showExperienciaForm">
									<!-- Icono llamativo -->
									<i class="bi bi-briefcase-fill display-1 text-primary mb-4"></i>

									<!-- Mensaje motivador -->
									<h4 class="fw-bold mb-3">¡Agrega tu experiencia profesional!</h4>
									<p class="text-muted mb-4">
										Registra tus experiencias laborales para fortalecer tu perfil profesional y
										mejorar tus oportunidades.
									</p>

									<!-- Botón de acción principal -->
									<button class="btn btn-primary btn-lg rounded-pill px-4 py-2"
										(click)="agregarExperiencia()">
										<i class="bi bi-plus-circle me-2"></i>Agregar Experiencia
									</button>
								</div> <!-- END Contenedor vacío -->

								<div *ngIf="!showExperienciaForm">
									<div class="mb-3" *ngFor="let exp of experiencia; let i = index">
										<div class="d-flex justify-content-between align-items-start">
											<div>
												<h6 class="mb-0">{{ exp.puesto }} en {{ exp.empresa }}</h6>
												<small class="text-muted">
													{{ exp.periodo.fecha_inicio }} / {{
													exp.periodo.estoyLaborandoActualmente ? 'Trabajando' :
													exp.periodo.fecha_fin }}
												</small>
												<p class="mt-2">{{ exp.funciones }}</p>
											</div>
											<div class="ms-2">
												<button class="btn btn-link btn-sm text-decoration-none"
													(click)="editarExperiencia(i)">
													<i class="bi bi-pencil-square"></i>
												</button>
												<button class="btn btn-link btn-sm text-danger text-decoration-none"
													(click)="eliminarExperiencia(i)">
													<i class="bi bi-trash"></i>
												</button>
											</div>
										</div>
									</div>
								</div>

								<!-- Formulario dinámico -->
								<div *ngIf="showExperienciaForm" [formGroup]="experienciaForm"
									class="mt-3 border-top pt-3">
									<div class="mb-2">
										<label class="form-label">Puesto</label>
										<!-- <input class="form-control" formControlName="puesto" /> -->
										<ng-select [items]="catalogoPuestos" bindLabel="puesto" bindValue="puesto"
											[multiple]="false" class="form-select" formControlName="puesto">
										</ng-select>
									</div>
									<div class="mb-2">
										<label class="form-label">Empresa</label>
										<input class="form-control" formControlName="empresa" />
									</div>
									<div class="mb-2">
										<label class="form-label">Fecha de entrada</label>
										<input class="form-control" formControlName="fechaInicioExp" type="month" />
									</div>
									<div class="mb-2">
										<label class="form-label">Fecha de salida</label>
										<input class="form-control" formControlName="fechaFinExp" type="month" />
									</div>
									<div class="form-check mb-2">
										<input class="form-check-input" type="checkbox" formControlName="actualExp"
											id="actualTrabajo">
										<label class="form-check-label" for="actualTrabajo">
											Aún trabajo aquí
										</label>
									</div>
									<div class="mb-2">
										<label class="form-label">Actividades y logros</label>
										<textarea class="form-control" rows="3"
											formControlName="descripcion"></textarea>
									</div>
									<div class="d-flex justify-content-end gap-2 mt-3">
										<button class="btn btn-secondary"
											(click)="cancelarExperiencia()">Cancelar</button>
										<button class="btn btn-primary"
											[disabled]="!esFormularioExperienciaValido()">Guardar</button>
									</div>
								</div>

							</div>
						</div>
					</div>
				</div> <!-- END Experiencia laboral -->

				<!-- Estudios Académicos -->
				<div class="container" *ngIf="pasoActual === 4">
					<div class="d-flex justify-content-between align-items-center mb-2">
						<h5 class="fw-bold mb-0">Estudios Académicos</h5>
						<button class="btn btn-outline-primary btn-sm" (click)="agregarEstudio()">Agregar</button>
					</div>

					<div class="card shadow-sm mb-4">
						<div class="card-body">
							<!-- HTML vacío -->
							<div class="container my-5 text-center" *ngIf="estudios.length === 0 && !showFormEstudios">
								<!-- Icono llamativo -->
								<i class="bi bi-journal-bookmark-fill display-1 text-primary mb-4"></i>

								<!-- Mensaje motivador -->
								<h4 class="fw-bold mb-3">¡Agrega tus estudios académicos!</h4>
								<p class="text-muted mb-4">
									Registrar tu formación académica te permitirá resaltar tu perfil y mejorar tus
									posibilidades profesionales.
								</p>

								<!-- Botón de acción principal -->
								<button class="btn btn-primary btn-lg rounded-pill px-4 py-2"
									(click)="agregarEstudio()">
									<i class="bi bi-plus-circle me-2"></i>Agregar Estudios
								</button>
							</div><!-- END HTML vacío -->

							<div *ngIf="!showFormEstudios">
								<div class="mb-3" *ngFor="let est of estudios; let i = index">
									<div class="d-flex justify-content-between align-items-start">
										<div>
											<h6 class="mb-0">{{ est.grado }} en {{ est.institucion }}</h6>
											<small class="text-muted">
												{{ est.periodo.fecha_inicio }} / {{ est.periodo.enProceso ? 'Cursando' :
												est.periodo.fecha_fin }}
											</small>
											<p class="mt-2">{{ est.carrera }}</p>
										</div>
										<div class="ms-2">
											<button class="btn btn-link btn-sm text-decoration-none"
												(click)="editarEstudio(i)">
												<i class="bi bi-pencil-square"></i>
											</button>
											<button class="btn btn-link btn-sm text-danger text-decoration-none"
												(click)="eliminarEstudio(i)">
												<i class="bi bi-trash"></i>
											</button>
										</div>
									</div>
								</div>
							</div>

							<!-- Formulario dinámico para estudios -->
							<div *ngIf="showFormEstudios" [formGroup]="formEstudios" class="mt-3 border-top pt-3">
								<div class="row">
									<div class="col-md-6 mb-2">
										<label class="form-label">Nivel</label>
										<ng-select [items]="estudiosNivel" bindLabel="descripcion" bindValue="id"
											[multiple]="false" class="form-select" id="nivel"
											formControlName="nivel"></ng-select>
									</div>
									<div class="col-md-6 mb-2">
										<label class="form-label">Institución</label>
										<ng-select [items]="institucionAcademica" bindLabel="descripcion" bindValue="id"
											[multiple]="false" class="form-select" id="institucion"
											formControlName="institucion"></ng-select>
									</div>
								</div>

								<div class="mb-2">
									<label class="form-label">Título o carrera</label>
									<ng-select [items]="carreras" bindLabel="descripcion" bindValue="id"
										[multiple]="false" class="form-select" id="titulo"
										formControlName="titulo"></ng-select>
								</div>

								<div class="row">
									<div class="col-md-6 mb-2">
										<label class="form-label">Fecha de inicio</label>
										<input class="form-control" type="month" formControlName="anioInicio" />
									</div>
									<div class="col-md-6 mb-2">
										<label class="form-label">Fecha de término</label>
										<input class="form-control" type="month" formControlName="anioFin" />
									</div>
								</div>

								<div class="form-check mb-2">
									<input class="form-check-input" type="checkbox" formControlName="enProceso"
										id="sigueEstudio">
									<label class="form-check-label" for="sigueEstudio">Sigo estudiando</label>
								</div>
								<!-- 
					      <div class="mb-2">
					        <label class="form-label">Actividades y logros</label>
					        <textarea class="form-control" rows="3" formControlName="descripcion"></textarea>
					      </div> -->

								<div class="d-flex justify-content-end gap-2 mt-3">
									<button class="btn btn-secondary" (click)="cancelarEstudio()">Cancelar</button>
									<button class="btn btn-primary" [disabled]="!esFormularioEstudioValido()"
										(click)="guardarEstudio()">Guardar</button>
								</div>
							</div>
						</div>
					</div>
				</div> <!-- END Estudios Académicos -->

				<!-- Cursos o Certificaciones -->
				<div class="container" *ngIf="pasoActual === 5">
					<div class="d-flex justify-content-between align-items-center mb-2">
						<h5 class="fw-bold mb-0">Cursos o certificaciones</h5>
						<button class="btn btn-outline-primary btn-sm" (click)="agregarCursos()"
							*ngIf="cursos.length>0">Agregar</button>
					</div>

					<div class="card shadow-sm mb-4">
						<div class="card-body" *ngIf="cursos.length===0 && !showFormCursos">
							<div class="container my-5 text-center">
								<!-- Icono llamativo -->
								<i class="bi bi-mortarboard display-1 text-primary mb-4"></i>

								<!-- Mensaje motivador -->
								<h4 class="fw-bold mb-3">¡Agrega tus cursos o certificaciones!</h4>
								<p class="text-muted mb-4">
									Comparte los cursos o certificaciones que has realizado. Estos pueden potenciar tus
									oportunidades laborales y hacerte destacar.
								</p>

								<!-- Botón de acción principal -->
								<button class="btn btn-primary btn-lg rounded-pill px-4 py-2" (click)="agregarCursos()">
									<i class="bi bi-plus-circle me-2"></i>Agregar Curso o Certificación
								</button>
							</div>
						</div>


						<div class="card-body">
							<div *ngIf="!showFormCursos">
								<div class="col-12" *ngFor="let curso of cursos; let i = index">
									<div class="card shadow-sm border-0 rounded-4 hover-shadow">
										<div class="card-body d-flex justify-content-between align-items-center">
											<div>
												<h5 class="card-title mb-1 fw-semibold">{{curso.curso}}</h5>
												<small class="text-muted">
													{{ curso.periodo.fecha_inicio }} / {{ curso.periodo.enProceso ?
													'Cursando' : curso.periodo.fecha_fin }}
												</small>
												<p class="mt-2">{{ curso.institucion }}</p>
												<!-- <span class="badge bg-success px-3 py-2">{{cursos.nivel}}</span> -->
											</div>
											<div>
												<button class="btn btn-outline-primary btn-sm me-2 rounded-circle"
													title="Editar">
													<i class="bi bi-pencil"></i>
												</button>
												<button class="btn btn-outline-danger btn-sm rounded-circle"
													title="Eliminar">
													<i class="bi bi-trash"></i>
												</button>
											</div>
										</div>
									</div>
								</div>
							</div>

							<!-- Formulario dinámico para Cursos -->
							<div *ngIf="showFormCursos" [formGroup]="formCursos" class="mt-3 border-top pt-3">
								<div class="row">
									<div class="col-md-6 mb-2">
										<label class="form-label">Tipo de curso</label>
										<ng-select [items]="catalogoTipoCursos" bindLabel="descripcion" bindValue="id"
											[multiple]="false" class="form-select" id="nivel"
											formControlName="tipoCurso"></ng-select>
									</div>
									<div class="col-md-6 mb-2">
										<label class="form-label">Institución</label>
										<input class="form-control" type="text" formControlName="institucionCurso" />
									</div>
								</div>

								<div class="mb-2">
									<label class="form-label">Nombre del curso o certificación</label>
									<input class="form-control" type="text" formControlName="tituloCurso" />
								</div>

								<div class="row">
									<div class="col-md-6 mb-2">
										<label class="form-label">Fecha de inicio</label>
										<input class="form-control" type="month" formControlName="fechaInicioCurso" />
									</div>
									<div class="col-md-6 mb-2">
										<label class="form-label">Fecha de término</label>
										<input class="form-control" type="month" formControlName="fechaFinCurso" />
									</div>
								</div>

								<div class="d-flex justify-content-end gap-2 mt-3">
									<button class="btn btn-secondary" (click)="cancelarCursos()">Cancelar</button>
									<button class="btn btn-primary" (click)="guardarCursos()">Guardar</button>
								</div>
							</div>
						</div>

					</div>
				</div> <!-- END Cursos o certificaciones -->

				<!-- Idiomas -->
				<div class="container" *ngIf="pasoActual === 6">
					<div class="container my-4">
						<div class="d-flex justify-content-between align-items-start mb-2">
							<h4 class="mb-4 fw-bold">Idiomas</h4>
							<div class="mt-4">
								<button class="btn btn-outline-secondary rounded-pill px-4 py-2"
									(click)="agregarIdioma()" *ngIf="idiomas.length > 0">
									<i class="bi bi-plus-circle me-2"></i>Agregar
								</button>
							</div>
						</div>

						<!-- Lista de idiomas -->
						<div class="row g-3">

							<div class="card">
								<div class="card-body container my-5 text-center"
									*ngIf="idiomas.length === 0 && !showFormIdiomas">
									<!-- Icono llamativo -->
									<i class="bi bi-translate display-1 text-primary mb-4"></i>

									<!-- Mensaje motivador -->
									<h4 class="fw-bold mb-3">¡Agrega tus idiomas!</h4>
									<p class="text-muted mb-4">
										Registra los idiomas que dominas y destaca tus habilidades lingüísticas. Esto
										puede mejorar tus oportunidades laborales.
									</p>

									<!-- Botón de acción principal -->
									<button class="btn btn-primary btn-lg rounded-pill px-4 py-2"
										(click)="agregarIdioma()">
										<i class="bi bi-plus-circle me-2"></i>Agregar Idioma
									</button>
								</div>
							</div>


							<div class="col-12" *ngFor="let idioma of idiomas; let i = index">
								<div class="card shadow-sm border-0 rounded-4 hover-shadow">
									<div class="card-body d-flex justify-content-between align-items-center">
										<div>
											<h5 class="card-title mb-1 fw-semibold">{{idioma.idioma}}</h5>
											<span class="badge bg-success px-3 py-2">{{idioma.nivel}}</span>
										</div>
										<div>
											<button class="btn btn-outline-primary btn-sm me-2 rounded-circle"
												title="Editar">
												<i class="bi bi-pencil"></i>
											</button>
											<button class="btn btn-outline-danger btn-sm rounded-circle"
												title="Eliminar">
												<i class="bi bi-trash"></i>
											</button>
										</div>
									</div>
								</div>
							</div>

							<!-- Formulario dinámico para Cursos -->
							<div *ngIf="showFormIdiomas" [formGroup]="formIdiomas" class="card mt-3 border-top pt-3">
								<div class="card-body">
									<div class="row">
										<div class="col-md-6 mb-2">
											<label class="form-label">Idioma</label>
											<ng-select [items]="catalogoIdiomas" bindLabel="descripcion" bindValue="id"
												[multiple]="false" class="form-select" id="idioma"
												formControlName="idioma"></ng-select>
										</div>
										<div class="col-md-6 mb-2">
											<label class="form-label">Nivel de manejo</label>
											<ng-select [items]="catalogoNivelManejoIdiomas" bindLabel="descripcion"
												bindValue="id" [multiple]="false" class="form-select" id="nivelManejo"
												formControlName="nivelManejo"></ng-select>
										</div>
									</div>

									<div class="d-flex justify-content-end gap-2 mt-3">
										<button class="btn btn-secondary" (click)="cancelarIdiomas()">Cancelar</button>
										<button class="btn btn-primary" (click)="guardarIdiomas()">Guardar</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div> <!-- END Idiomas -->

			</form-steps>
		</div>
	</div>
</div>